import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { PhotoProducts } from "@/components/site/PhotoProducts";
import { HotWaterSpecs } from "@/components/site/HotWaterSpecs";
import { Manifesto } from "@/components/site/Manifesto";
import { Impact } from "@/components/site/Impact";
import { Faq } from "@/components/site/Faq";
import { QuoteFooter } from "@/components/site/QuoteFooter";
import { IMG, HW_PRODUCTS, HW_CHAPTERS, HW_STATS, HW_FAQS, HW_PRODUCT_OPTIONS } from "@/components/site/data";
import { scrollToId } from "@/components/site/motion";
import { Seo } from "@/components/site/Seo";

const HW_MARQUEE = ["Evacuated Tube", "Solar Pool Heating", "Commercial Thermal", "Up to 90% Solar", "STC Rebates", "15-Year Collector Warranty", "Since 2009", "Australian Owned & Designed"];

export default function HotWaterPage() {
  return (
    <>
      <Seo
        path="/solar-hot-water"
        title="Solar Hot Water Systems"
        description="High-efficiency evacuated tube solar hot water, pool heating and commercial solar thermal systems — up to 90% of your water heating from the sun. STC rebates available."
      />
      <Hero
        overline="Solar Hot Water · Est. 2009"
        line1="Endless hot water,"
        line2Prefix="from the"
        line2Highlight="sun."
        subtitle={<>High-efficiency <span className="text-white font-semibold">evacuated tube solar hot water</span>, pool heating and commercial thermal systems — up to <span className="text-white font-semibold">90% of your water heating</span> from the sun.</>}
        bgImage={IMG.hwHero}
        secondaryLabel="Explore Range"
        onSecondary={() => scrollToId("products")}
      />
      <Marquee items={HW_MARQUEE} />
      <PhotoProducts
        overline="The Range"
        title={<>Solar thermal for<br />every application.</>}
        subtitle="From residential evacuated tube systems to industrial-scale solar thermal plants — precision-engineered for the Australian climate."
        products={HW_PRODUCTS}
      />
      <HotWaterSpecs />
      <Manifesto
        overline="Why Solar Thermal"
        title="A manifesto for the sun."
        subtitle="Four principles behind every solar hot water system we design, build and install across Australia."
        chapters={HW_CHAPTERS}
      />
      <Impact overline="The Numbers" title="Fifteen years of solar thermal engineering." stats={HW_STATS} />
      <Faq title="Solar hot water, answered." faqs={HW_FAQS} />
      <QuoteFooter productOptions={HW_PRODUCT_OPTIONS} blurb="Tell us about your property and our engineering team will design the right solar hot water system, calculate your rebates, and connect you with a licensed installer from our national network — no obligation." />
    </>
  );
}
